module.exports = __webpack_public_path__ + "img/4143208.jpg";